// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/login.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
  width: 100%;
  height: 100vh;
  margin: 0 !important;
  position: relative;
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.425)), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  background-size: cover;
}
.login .intro {
  text-align: center;
  max-width: 60%;
}
.login .intro h1 {
  color: #fff;
  font-weight: 900;
}
.login .intro h2 {
  color: var(--headerFont);
}
.login .logo {
  position: absolute;
  top: 20px;
  left: 20px;
}
.login .logo img {
  width: 100px;
  display: inline-block;
}

@media (max-width: 550px) {
  .login {
    background: #fff;
  }
  .login .logo h1 {
    color: var(--headerFont);
  }
  .dark .login {
    background: #151515;
  }
}
@media (max-width: 340px) {
  .login .logo {
    left: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Auth/auth.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,sIAAA;EAEA,sBAAA;AAAF;AACE;EACE,kBAAA;EACA,cAAA;AACJ;AAAI;EACE,WAAA;EACA,gBAAA;AAEN;AAAI;EACE,wBAAA;AAEN;AACE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AACJ;AAAI;EACE,YAAA;EACA,qBAAA;AAEN;;AAGA;EACE;IACE,gBAAA;EAAF;EAEI;IACE,wBAAA;EAAN;EAKE;IACE,mBAAA;EAHJ;AACF;AAMA;EAEI;IACE,UAAA;EALJ;AACF","sourcesContent":[".login {\n  width: 100%;\n  height: 100vh;\n  margin: 0 !important;\n  position: relative;\n  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.425)),\n    url(../../assets/images/login.svg) center center no-repeat;\n  background-size: cover;\n  .intro {\n    text-align: center;\n    max-width: 60%;\n    h1 {\n      color: #fff;\n      font-weight: 900;\n    }\n    h2 {\n      color: var(--headerFont);\n    }\n  }\n  .logo {\n    position: absolute;\n    top: 20px;\n    left: 20px;\n    img {\n      width: 100px;\n      display: inline-block;\n    }\n  }\n}\n\n@media (max-width: 550px) {\n  .login {\n    background: #fff;\n    .logo {\n      h1 {\n        color: var(--headerFont);\n      }\n    }\n  }\n  .dark {\n    .login {\n      background: #151515;\n    }\n  }\n}\n@media (max-width: 340px) {\n  .login {\n    .logo {\n      left: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
